var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridWidget',{attrs:{"cols":_vm.cols,"gap":_vm.gap}},[_vm._t("default")],2),(_vm.countPages > 1)?_c('PaginationWidget',{staticClass:"mt-10",attrs:{"count":_vm.countPages}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }